import { getFullUserName } from "@/common/helpers/get-full-user-name";
import { useLogout } from "@/common/hooks/use-logout";
import { Button, ButtonColorVariant, ButtonSize, ButtonVariant } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useSidebar } from "@/components/ui/sidebar";
import { userStore } from "@/store/user-store";
import { ChevronDown, LogOut, Settings } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "wouter";
import { UserAvatar, UserAvatarSize } from "../user-avatar/user-avatar";
import { AppearanceMenuItems } from "./_components/appearance-menu-items";

export function UserMenu() {
  const { t } = useTranslation();
  const user = userStore((state) => state.user);
  const logout = useLogout();
  const { setOpenMobile } = useSidebar();

  const fullUserName = user ? getFullUserName({ user }) : "";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant={ButtonVariant.Ghost}
          colorVariant={ButtonColorVariant.Secondary}
          size={ButtonSize.Sm}
          className="data-[state=open]:bg-accent data-[state=open]:text-accent-foreground h-10 gap-2 rounded-full px-1 sm:rounded-md sm:px-1.5"
          aria-label={t("UserMenuOpen")}
        >
          <UserAvatar userAzureObjectUuid={user?.azureObjectUuid} name={fullUserName} size={UserAvatarSize.Sm} />
          <div className="hidden min-w-0 flex-col items-start text-left md:flex">
            <span className="max-w-36 truncate text-sm leading-tight font-semibold">{fullUserName}</span>
            <span className="text-muted-foreground max-w-36 truncate text-xs leading-tight font-normal">
              {user?.email}
            </span>
          </div>
          <ChevronDown className="text-muted-foreground hidden size-4 md:block" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="min-w-56 rounded-lg" side="bottom" align="end" sideOffset={4}>
        <AppearanceMenuItems />
        <DropdownMenuItem asChild>
          <Link to="~/settings" className="flex cursor-pointer items-center gap-2" onClick={() => setOpenMobile(false)}>
            <Settings />
            <p>{t("user-settings:Settings")}</p>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            setOpenMobile(false);
            void logout();
          }}
        >
          <LogOut />
          <p>{t("Logout")}</p>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
